// This file is automatically generated from Rails routes.
// DO NOT modify it manually.
// To regenerate, run: bin/rake gitlab:js:routes

import { __jsr } from '~/lib/utils/path_helpers/core';
import { resolveOrganizationScope, splitProjectFullPath } from '~/lib/utils/path_helpers/utils';


/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id(.:format)`
 * - Path helper: `project_merge_request_path`
 * - URL helper: `project_merge_request_url`
 * - controller#action: `projects/merge_requests#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/commit_change_content(.:format)`
 * - Path helper: `commit_change_content_project_merge_request_path`
 * - URL helper: `commit_change_content_project_merge_request_url`
 * - controller#action: `projects/merge_requests#commit_change_content`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const commitChangeContentProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _commitChangeContentOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"commit_change_content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _commitChangeContentNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"commit_change_content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _commitChangeContentOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _commitChangeContentNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/merge(.:format)`
 * - Path helper: `merge_project_merge_request_path`
 * - URL helper: `merge_project_merge_request_url`
 * - controller#action: `projects/merge_requests#merge`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const mergeProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _mergeOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _mergeNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _mergeOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _mergeNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/cancel_auto_merge(.:format)`
 * - Path helper: `cancel_auto_merge_project_merge_request_path`
 * - URL helper: `cancel_auto_merge_project_merge_request_url`
 * - controller#action: `projects/merge_requests#cancel_auto_merge`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const cancelAutoMergeProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _cancelAutoMergeOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_auto_merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _cancelAutoMergeNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_auto_merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _cancelAutoMergeOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _cancelAutoMergeNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/pipeline_status(.:format)`
 * - Path helper: `pipeline_status_project_merge_request_path`
 * - URL helper: `pipeline_status_project_merge_request_url`
 * - controller#action: `projects/merge_requests#pipeline_status`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const pipelineStatusProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _pipelineStatusOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pipeline_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _pipelineStatusNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pipeline_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _pipelineStatusOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _pipelineStatusNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/ci_environments_status(.:format)`
 * - Path helper: `ci_environments_status_project_merge_request_path`
 * - URL helper: `ci_environments_status_project_merge_request_url`
 * - controller#action: `projects/merge_requests#ci_environments_status`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const ciEnvironmentsStatusProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _ciEnvironmentsStatusOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ci_environments_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _ciEnvironmentsStatusNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ci_environments_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _ciEnvironmentsStatusOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _ciEnvironmentsStatusNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/toggle_subscription(.:format)`
 * - Path helper: `toggle_subscription_project_merge_request_path`
 * - URL helper: `toggle_subscription_project_merge_request_url`
 * - controller#action: `projects/merge_requests#toggle_subscription`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const toggleSubscriptionProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _toggleSubscriptionOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _toggleSubscriptionNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _toggleSubscriptionOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _toggleSubscriptionNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/remove_wip(.:format)`
 * - Path helper: `remove_wip_project_merge_request_path`
 * - URL helper: `remove_wip_project_merge_request_url`
 * - controller#action: `projects/merge_requests#remove_wip`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const removeWipProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _removeWipOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_wip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _removeWipNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_wip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _removeWipOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _removeWipNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/assign_related_issues(.:format)`
 * - Path helper: `assign_related_issues_project_merge_request_path`
 * - URL helper: `assign_related_issues_project_merge_request_url`
 * - controller#action: `projects/merge_requests#assign_related_issues`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const assignRelatedIssuesProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _assignRelatedIssuesOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_related_issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _assignRelatedIssuesNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_related_issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _assignRelatedIssuesOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _assignRelatedIssuesNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/discussions(.:format)`
 * - Path helper: `discussions_project_merge_request_path`
 * - URL helper: `discussions_project_merge_request_url`
 * - controller#action: `projects/merge_requests#discussions`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const discussionsProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _discussionsOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discussions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _discussionsNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discussions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _discussionsOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _discussionsNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/rebase(.:format)`
 * - Path helper: `rebase_project_merge_request_path`
 * - URL helper: `rebase_project_merge_request_url`
 * - controller#action: `projects/merge_requests#rebase`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const rebaseProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _rebaseOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rebase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _rebaseNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rebase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _rebaseOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _rebaseNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/test_reports(.:format)`
 * - Path helper: `test_reports_project_merge_request_path`
 * - URL helper: `test_reports_project_merge_request_url`
 * - controller#action: `projects/merge_requests#test_reports`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const testReportsProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _testReportsOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _testReportsNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _testReportsOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _testReportsNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/exposed_artifacts(.:format)`
 * - Path helper: `exposed_artifacts_project_merge_request_path`
 * - URL helper: `exposed_artifacts_project_merge_request_url`
 * - controller#action: `projects/merge_requests#exposed_artifacts`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const exposedArtifactsProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _exposedArtifactsOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"exposed_artifacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _exposedArtifactsNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"exposed_artifacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _exposedArtifactsOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _exposedArtifactsNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/accessibility_reports(.:format)`
 * - Path helper: `accessibility_reports_project_merge_request_path`
 * - URL helper: `accessibility_reports_project_merge_request_url`
 * - controller#action: `projects/merge_requests#accessibility_reports`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const accessibilityReportsProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _accessibilityReportsOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accessibility_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _accessibilityReportsNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accessibility_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _accessibilityReportsOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _accessibilityReportsNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/coverage_reports(.:format)`
 * - Path helper: `coverage_reports_project_merge_request_path`
 * - URL helper: `coverage_reports_project_merge_request_url`
 * - controller#action: `projects/merge_requests#coverage_reports`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const coverageReportsProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _coverageReportsOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"coverage_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _coverageReportsNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"coverage_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _coverageReportsOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _coverageReportsNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/terraform_reports(.:format)`
 * - Path helper: `terraform_reports_project_merge_request_path`
 * - URL helper: `terraform_reports_project_merge_request_url`
 * - controller#action: `projects/merge_requests#terraform_reports`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const terraformReportsProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _terraformReportsOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"terraform_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _terraformReportsNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"terraform_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _terraformReportsOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _terraformReportsNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/codequality_reports(.:format)`
 * - Path helper: `codequality_reports_project_merge_request_path`
 * - URL helper: `codequality_reports_project_merge_request_url`
 * - controller#action: `projects/merge_requests#codequality_reports`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const codequalityReportsProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _codequalityReportsOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"codequality_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _codequalityReportsNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"codequality_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _codequalityReportsOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _codequalityReportsNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/codequality_mr_diff_reports(.:format)`
 * - Path helper: `codequality_mr_diff_reports_project_merge_request_path`
 * - URL helper: `codequality_mr_diff_reports_project_merge_request_url`
 * - controller#action: `projects/merge_requests#codequality_mr_diff_reports`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const codequalityMrDiffReportsProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _codequalityMrDiffReportsOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"codequality_mr_diff_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _codequalityMrDiffReportsNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"codequality_mr_diff_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _codequalityMrDiffReportsOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _codequalityMrDiffReportsNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/commits(.:format)`
 * - Path helper: `commits_project_json_merge_request_path`
 * - URL helper: `commits_project_json_merge_request_url`
 * - controller#action: `projects/merge_requests#commits`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const commitsProjectJsonMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _commitsOrganizationNamespaceProjectJsonMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"commits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _commitsNamespaceProjectJsonMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"commits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _commitsOrganizationNamespaceProjectJsonMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _commitsNamespaceProjectJsonMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/pipelines(.:format)`
 * - Path helper: `pipelines_project_json_merge_request_path`
 * - URL helper: `pipelines_project_json_merge_request_url`
 * - controller#action: `projects/merge_requests#pipelines`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const pipelinesProjectJsonMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _pipelinesOrganizationNamespaceProjectJsonMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pipelines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _pipelinesNamespaceProjectJsonMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pipelines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _pipelinesOrganizationNamespaceProjectJsonMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _pipelinesNamespaceProjectJsonMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/context_commits(.:format)`
 * - Path helper: `context_commits_project_json_merge_request_path`
 * - URL helper: `context_commits_project_json_merge_request_url`
 * - controller#action: `projects/merge_requests#context_commits`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const contextCommitsProjectJsonMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _contextCommitsOrganizationNamespaceProjectJsonMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"context_commits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _contextCommitsNamespaceProjectJsonMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"context_commits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _contextCommitsOrganizationNamespaceProjectJsonMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _contextCommitsNamespaceProjectJsonMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/diffs(.:format)`
 * - Path helper: `diffs_project_json_merge_request_path`
 * - URL helper: `diffs_project_json_merge_request_url`
 * - controller#action: `projects/merge_requests/diffs#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const diffsProjectJsonMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _diffsOrganizationNamespaceProjectJsonMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diffs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _diffsNamespaceProjectJsonMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diffs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _diffsOrganizationNamespaceProjectJsonMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _diffsNamespaceProjectJsonMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/diffs_batch(.:format)`
 * - Path helper: `diffs_batch_project_json_merge_request_path`
 * - URL helper: `diffs_batch_project_json_merge_request_url`
 * - controller#action: `projects/merge_requests/diffs#diffs_batch`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const diffsBatchProjectJsonMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _diffsBatchOrganizationNamespaceProjectJsonMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diffs_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _diffsBatchNamespaceProjectJsonMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diffs_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _diffsBatchOrganizationNamespaceProjectJsonMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _diffsBatchNamespaceProjectJsonMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/diffs_metadata(.:format)`
 * - Path helper: `diffs_metadata_project_json_merge_request_path`
 * - URL helper: `diffs_metadata_project_json_merge_request_url`
 * - controller#action: `projects/merge_requests/diffs#diffs_metadata`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const diffsMetadataProjectJsonMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _diffsMetadataOrganizationNamespaceProjectJsonMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diffs_metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _diffsMetadataNamespaceProjectJsonMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diffs_metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _diffsMetadataOrganizationNamespaceProjectJsonMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _diffsMetadataNamespaceProjectJsonMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/widget(.:format)`
 * - Path helper: `widget_project_json_merge_request_path`
 * - URL helper: `widget_project_json_merge_request_url`
 * - controller#action: `projects/merge_requests/content#widget`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const widgetProjectJsonMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _widgetOrganizationNamespaceProjectJsonMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"widget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _widgetNamespaceProjectJsonMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"widget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _widgetOrganizationNamespaceProjectJsonMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _widgetNamespaceProjectJsonMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/cached_widget(.:format)`
 * - Path helper: `cached_widget_project_json_merge_request_path`
 * - URL helper: `cached_widget_project_json_merge_request_url`
 * - controller#action: `projects/merge_requests/content#cached_widget`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const cachedWidgetProjectJsonMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _cachedWidgetOrganizationNamespaceProjectJsonMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cached_widget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _cachedWidgetNamespaceProjectJsonMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cached_widget"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _cachedWidgetOrganizationNamespaceProjectJsonMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _cachedWidgetNamespaceProjectJsonMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/diffs(.:format)`
 * - Path helper: `diffs_project_merge_request_path`
 * - URL helper: `diffs_project_merge_request_url`
 * - controller#action: `projects/merge_requests/diffs#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const diffsProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _diffsOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diffs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _diffsNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diffs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _diffsOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _diffsNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/commits(.:format)`
 * - Path helper: `commits_project_merge_request_path`
 * - URL helper: `commits_project_merge_request_url`
 * - controller#action: `projects/merge_requests#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const commitsProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _commitsOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"commits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _commitsNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"commits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _commitsOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _commitsNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/pipelines(.:format)`
 * - Path helper: `pipelines_project_merge_request_path`
 * - URL helper: `pipelines_project_merge_request_url`
 * - controller#action: `projects/merge_requests#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const pipelinesProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _pipelinesOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pipelines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _pipelinesNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pipelines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _pipelinesOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _pipelinesNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/diff_for_path(.:format)`
 * - Path helper: `diff_for_path_project_merge_request_path`
 * - URL helper: `diff_for_path_project_merge_request_url`
 * - controller#action: `projects/merge_requests/diffs#diff_for_path`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const diffForPathProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _diffForPathOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diff_for_path"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _diffForPathNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diff_for_path"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _diffForPathOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _diffForPathNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/diff_by_file_hash/:file_hash(.:format)`
 * - Path helper: `diff_by_file_hash_project_merge_request_path`
 * - URL helper: `diff_by_file_hash_project_merge_request_url`
 * - controller#action: `projects/merge_requests/diffs#diff_by_file_hash`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {any} fileHash
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const diffByFileHashProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _diffByFileHashOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"file_hash":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diff_by_file_hash"],[2,[7,"/"],[2,[3,"file_hash"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _diffByFileHashNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"file_hash":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diff_by_file_hash"],[2,[7,"/"],[2,[3,"file_hash"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _diffByFileHashOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _diffByFileHashNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/diffs_stream(.:format)`
 * - Path helper: `diffs_stream_project_merge_request_path`
 * - URL helper: `diffs_stream_project_merge_request_url`
 * - controller#action: `projects/merge_requests/diffs_stream#diffs_stream`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const diffsStreamProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _diffsStreamOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diffs_stream"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _diffsStreamNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diffs_stream"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _diffsStreamOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _diffsStreamNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/diff_files_metadata(.:format)`
 * - Path helper: `diff_files_metadata_project_merge_request_path`
 * - URL helper: `diff_files_metadata_project_merge_request_url`
 * - controller#action: `projects/merge_requests#diff_files_metadata`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const diffFilesMetadataProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _diffFilesMetadataOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diff_files_metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _diffFilesMetadataNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diff_files_metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _diffFilesMetadataOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _diffFilesMetadataNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/diffs_stats(.:format)`
 * - Path helper: `diffs_stats_project_merge_request_path`
 * - URL helper: `diffs_stats_project_merge_request_url`
 * - controller#action: `projects/merge_requests#diffs_stats`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const diffsStatsProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _diffsStatsOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diffs_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _diffsStatsNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diffs_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _diffsStatsOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _diffsStatsNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/diff_file(.:format)`
 * - Path helper: `diff_file_project_merge_request_path`
 * - URL helper: `diff_file_project_merge_request_url`
 * - controller#action: `projects/merge_requests#diff_file`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const diffFileProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _diffFileOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diff_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _diffFileNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"diff_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _diffFileOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _diffFileNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/versions(.:format)`
 * - Path helper: `versions_project_merge_request_path`
 * - URL helper: `versions_project_merge_request_url`
 * - controller#action: `projects/merge_requests#versions`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const versionsProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _versionsOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"versions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _versionsNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"versions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _versionsOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _versionsNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/conflicts(.:format)`
 * - Path helper: `conflicts_project_merge_request_path`
 * - URL helper: `conflicts_project_merge_request_url`
 * - controller#action: `projects/merge_requests/conflicts#show`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const conflictsProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _conflictsOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"conflicts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _conflictsNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"conflicts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _conflictsOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _conflictsNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/conflict_for_path(.:format)`
 * - Path helper: `conflict_for_path_project_merge_request_path`
 * - URL helper: `conflict_for_path_project_merge_request_url`
 * - controller#action: `projects/merge_requests/conflicts#conflict_for_path`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const conflictForPathProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _conflictForPathOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"conflict_for_path"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _conflictForPathNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"conflict_for_path"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _conflictForPathOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _conflictForPathNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/resolve_conflicts(.:format)`
 * - Path helper: `resolve_conflicts_project_merge_request_path`
 * - URL helper: `resolve_conflicts_project_merge_request_url`
 * - controller#action: `projects/merge_requests/conflicts#resolve_conflicts`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const resolveConflictsProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _resolveConflictsOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve_conflicts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _resolveConflictsNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve_conflicts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _resolveConflictsOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _resolveConflictsNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/diff_for_path(.:format)`
 * - Path helper: `diff_for_path_project_merge_requests_path`
 * - URL helper: `diff_for_path_project_merge_requests_url`
 * - controller#action: `projects/merge_requests#diff_for_path`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const diffForPathProjectMergeRequestsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _diffForPathOrganizationNamespaceProjectMergeRequestsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"diff_for_path"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _diffForPathNamespaceProjectMergeRequestsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"diff_for_path"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _diffForPathOrganizationNamespaceProjectMergeRequestsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _diffForPathNamespaceProjectMergeRequestsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/bulk_update(.:format)`
 * - Path helper: `bulk_update_project_merge_requests_path`
 * - URL helper: `bulk_update_project_merge_requests_url`
 * - controller#action: `projects/merge_requests#bulk_update`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const bulkUpdateProjectMergeRequestsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _bulkUpdateOrganizationNamespaceProjectMergeRequestsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _bulkUpdateNamespaceProjectMergeRequestsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _bulkUpdateOrganizationNamespaceProjectMergeRequestsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _bulkUpdateNamespaceProjectMergeRequestsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/export_csv(.:format)`
 * - Path helper: `export_csv_project_merge_requests_path`
 * - URL helper: `export_csv_project_merge_requests_url`
 * - controller#action: `projects/merge_requests#export_csv`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const exportCsvProjectMergeRequestsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _exportCsvOrganizationNamespaceProjectMergeRequestsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _exportCsvNamespaceProjectMergeRequestsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _exportCsvOrganizationNamespaceProjectMergeRequestsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _exportCsvNamespaceProjectMergeRequestsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:merge_request_id/drafts/publish(.:format)`
 * - Path helper: `publish_project_merge_request_drafts_path`
 * - URL helper: `publish_project_merge_request_drafts_url`
 * - controller#action: `projects/merge_requests/drafts#publish`
 *
 * @param {string} projectFullPath
 * @param {any} mergeRequestId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const publishProjectMergeRequestDraftsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _publishOrganizationNamespaceProjectMergeRequestDraftsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"merge_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"merge_request_id"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _publishNamespaceProjectMergeRequestDraftsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"merge_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"merge_request_id"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _publishOrganizationNamespaceProjectMergeRequestDraftsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _publishNamespaceProjectMergeRequestDraftsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:merge_request_id/drafts/discard(.:format)`
 * - Path helper: `discard_project_merge_request_drafts_path`
 * - URL helper: `discard_project_merge_request_drafts_url`
 * - controller#action: `projects/merge_requests/drafts#discard`
 *
 * @param {string} projectFullPath
 * @param {any} mergeRequestId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const discardProjectMergeRequestDraftsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _discardOrganizationNamespaceProjectMergeRequestDraftsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"merge_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"merge_request_id"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _discardNamespaceProjectMergeRequestDraftsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"merge_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"merge_request_id"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _discardOrganizationNamespaceProjectMergeRequestDraftsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _discardNamespaceProjectMergeRequestDraftsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:merge_request_id/drafts(.:format)`
 * - Path helper: `project_merge_request_drafts_path`
 * - URL helper: `project_merge_request_drafts_url`
 * - controller#action: `projects/merge_requests/drafts#index`
 *
 * @param {string} projectFullPath
 * @param {any} mergeRequestId
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectMergeRequestDraftsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMergeRequestDraftsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"merge_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"merge_request_id"],[2,[7,"/"],[2,[6,"drafts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectMergeRequestDraftsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"merge_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"merge_request_id"],[2,[7,"/"],[2,[6,"drafts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectMergeRequestDraftsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectMergeRequestDraftsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:merge_request_id/drafts/:id(.:format)`
 * - Path helper: `project_merge_request_draft_path`
 * - URL helper: `project_merge_request_draft_url`
 * - controller#action: `projects/merge_requests/drafts#update`
 *
 * @param {string} projectFullPath
 * @param {any} mergeRequestId
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectMergeRequestDraftPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMergeRequestDraftPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"merge_request_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"merge_request_id"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectMergeRequestDraftPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"merge_request_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"merge_request_id"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectMergeRequestDraftPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectMergeRequestDraftPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests(.:format)`
 * - Path helper: `project_merge_requests_path`
 * - URL helper: `project_merge_requests_url`
 * - controller#action: `projects/merge_requests#index`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectMergeRequestsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMergeRequestsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectMergeRequestsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectMergeRequestsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectMergeRequestsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/:id/edit(.:format)`
 * - Path helper: `edit_project_merge_request_path`
 * - URL helper: `edit_project_merge_request_url`
 * - controller#action: `projects/merge_requests#edit`
 *
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editProjectMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationNamespaceProjectMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _editNamespaceProjectMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/new(.:format)`
 * - Path helper: `project_new_merge_request_path`
 * - URL helper: `project_new_merge_request_url`
 * - controller#action: `projects/merge_requests/creations#new`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectNewMergeRequestPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectNewMergeRequestPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectNewMergeRequestPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectNewMergeRequestPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectNewMergeRequestPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/new/diffs(.:format)`
 * - Path helper: `project_new_merge_request_json_diffs_path`
 * - URL helper: `project_new_merge_request_json_diffs_url`
 * - controller#action: `projects/merge_requests/creations#diffs`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectNewMergeRequestJsonDiffsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectNewMergeRequestJsonDiffsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"diffs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectNewMergeRequestJsonDiffsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"diffs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectNewMergeRequestJsonDiffsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectNewMergeRequestJsonDiffsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/new/pipelines(.:format)`
 * - Path helper: `project_new_merge_request_json_pipelines_path`
 * - URL helper: `project_new_merge_request_json_pipelines_url`
 * - controller#action: `projects/merge_requests/creations#pipelines`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectNewMergeRequestJsonPipelinesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectNewMergeRequestJsonPipelinesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"pipelines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectNewMergeRequestJsonPipelinesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"pipelines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectNewMergeRequestJsonPipelinesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectNewMergeRequestJsonPipelinesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/new/diffs(.:format)`
 * - Path helper: `project_new_merge_request_diffs_path`
 * - URL helper: `project_new_merge_request_diffs_url`
 * - controller#action: `projects/merge_requests/creations#new`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectNewMergeRequestDiffsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectNewMergeRequestDiffsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"diffs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectNewMergeRequestDiffsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"diffs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectNewMergeRequestDiffsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectNewMergeRequestDiffsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/new/pipelines(.:format)`
 * - Path helper: `project_new_merge_request_pipelines_path`
 * - URL helper: `project_new_merge_request_pipelines_url`
 * - controller#action: `projects/merge_requests/creations#new`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectNewMergeRequestPipelinesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectNewMergeRequestPipelinesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"pipelines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectNewMergeRequestPipelinesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"pipelines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectNewMergeRequestPipelinesPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectNewMergeRequestPipelinesPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/new/diff_for_path(.:format)`
 * - Path helper: `project_new_merge_request_diff_for_path_path`
 * - URL helper: `project_new_merge_request_diff_for_path_url`
 * - controller#action: `projects/merge_requests/creations#diff_for_path`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectNewMergeRequestDiffForPathPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectNewMergeRequestDiffForPathPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"diff_for_path"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectNewMergeRequestDiffForPathPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"diff_for_path"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectNewMergeRequestDiffForPathPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectNewMergeRequestDiffForPathPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/new/branch_from(.:format)`
 * - Path helper: `project_new_merge_request_branch_from_path`
 * - URL helper: `project_new_merge_request_branch_from_url`
 * - controller#action: `projects/merge_requests/creations#branch_from`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectNewMergeRequestBranchFromPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectNewMergeRequestBranchFromPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"branch_from"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectNewMergeRequestBranchFromPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"branch_from"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectNewMergeRequestBranchFromPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectNewMergeRequestBranchFromPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/new/branch_to(.:format)`
 * - Path helper: `project_new_merge_request_branch_to_path`
 * - URL helper: `project_new_merge_request_branch_to_url`
 * - controller#action: `projects/merge_requests/creations#branch_to`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectNewMergeRequestBranchToPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectNewMergeRequestBranchToPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"branch_to"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectNewMergeRequestBranchToPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"branch_to"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectNewMergeRequestBranchToPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectNewMergeRequestBranchToPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/new/diffs_stream(.:format)`
 * - Path helper: `project_new_merge_request_diffs_stream_path`
 * - URL helper: `project_new_merge_request_diffs_stream_url`
 * - controller#action: `projects/merge_requests/creations_diffs_stream#diffs_stream`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectNewMergeRequestDiffsStreamPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectNewMergeRequestDiffsStreamPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"diffs_stream"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectNewMergeRequestDiffsStreamPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"diffs_stream"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectNewMergeRequestDiffsStreamPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectNewMergeRequestDiffsStreamPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/new/diff_files_metadata(.:format)`
 * - Path helper: `project_new_merge_request_diff_files_metadata_path`
 * - URL helper: `project_new_merge_request_diff_files_metadata_url`
 * - controller#action: `projects/merge_requests/creations#diff_files_metadata`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectNewMergeRequestDiffFilesMetadataPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectNewMergeRequestDiffFilesMetadataPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"diff_files_metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectNewMergeRequestDiffFilesMetadataPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"diff_files_metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectNewMergeRequestDiffFilesMetadataPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectNewMergeRequestDiffFilesMetadataPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/new/diffs_stats(.:format)`
 * - Path helper: `project_new_merge_request_diffs_stats_path`
 * - URL helper: `project_new_merge_request_diffs_stats_url`
 * - controller#action: `projects/merge_requests/creations#diffs_stats`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectNewMergeRequestDiffsStatsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectNewMergeRequestDiffsStatsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"diffs_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectNewMergeRequestDiffsStatsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"diffs_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectNewMergeRequestDiffsStatsPath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectNewMergeRequestDiffsStatsPath(namespacePath, projectPath, ...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/:project_full_path/-/merge_requests/new/diff_file(.:format)`
 * - Path helper: `project_new_merge_request_diff_file_path`
 * - URL helper: `project_new_merge_request_diff_file_url`
 * - controller#action: `projects/merge_requests/creations#diff_file`
 *
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const projectNewMergeRequestDiffFilePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectNewMergeRequestDiffFilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"diff_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectNewMergeRequestDiffFilePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"diff_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);
  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationNamespaceProjectNewMergeRequestDiffFilePath(organizationPath, namespacePath, projectPath, ...routeArgs);
  }

  return _namespaceProjectNewMergeRequestDiffFilePath(namespacePath, projectPath, ...routeArgs);
};

